<template>
  <div class="comp-download">
    <ul v-if="data && data.length" :class="'comp-download--' + size">
      <li v-for="(item, i) in data" :key="i">
        <span class="ext" :class="item.FileFileExtension"></span>
        <a
          class="name"
          :download="item.FileFileName"
          :href="`/files/${item.FileFilePath}`"
          :target="target"
          >{{ item.Headline }}</a
        >
        <span class="date">{{ item.CreatedTime }}</span>
        <a
          v-if="item.FileFilePath"
          class="link"
          :download="item.FileFileName"
          :href="`/files/${item.FileFilePath}`"
          :target="target"
        >
          <svg-icon icon-class="download"></svg-icon>
        </a>
      </li>
    </ul>
    <div v-else class="g-nodata"></div>
  </div>
</template>

<script>
export default {
  name: "ic-download",
  props: {
    data: {
      type: Array
    },
    size: {
      type: String,
      default: "large"
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-download {
  display: flex;
  justify-content: space-between;
  ul {
    width: 100%;
  }
  li {
    border-bottom: 1px solid #eeeeee;
    display: flex;
    width: 100%;
    height: 64px;
    line-height: 64px;
    padding: 0 24px;
    align-items: center;
    .ext {
      width: 32px;
      margin-right: 16px;
      height: 38px;
      display: inline-block;
      &.doc,
      &.docx {
        background: url(~assets/img/doc.png) no-repeat left center;
      }
      &.ppt,
      &.pptx {
        background: url(~assets/img/ppt.png) no-repeat left center;
      }
    }
    .name {
      width: 868px;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }
    .date {
      width: 140px;
      padding-right: 88px;
      height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 22px;
    }
    .link {
      font-size: 22px;
      display: inline-block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      font-weight: bold;
      box-sizing: border-box;
      &:hover {
        border-color: $primary-color;
      }
    }
    &:hover {
      background: rgba(69, 80, 238, 0.1);
      box-shadow: 0px -1px 0px 0px rgba(238, 238, 238, 1);
      a {
        color: $primary-color;
        border-color: $primary-color;
      }
    }
  }
  &--small {
    li {
      height: 16px;
      line-height: 16px;
      padding: 12px 0 16px 0;
      &:hover {
        background-color: transparent;
      }
      .ext {
        width: 24px;
        background-size: 100% auto !important;
      }
      .name {
        font-size: 14px;
        width: 508px;
      }
      .date {
        display: none;
      }
      .link {
        font-size: 18px;
      }
    }
  }
}
</style>
